export const CONTACT_FIELD_CODES = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  phone: "phoneNumber",
};
